import { Flex } from '@chakra-ui/react'
import { Select } from '../Select'
import { FiClipboard, FiMessageCircle } from 'react-icons/fi'
import { useFormContext } from 'react-hook-form'
import { useAgendamentoRetorno } from '../../../../Modais/AgendamentoRetornoCliente/hooks/useAgendamentoRetorno'

export const WhatsAppOption = () => {
  const { watch } = useFormContext()
  const categorySelected = watch('categoria')
  const messageSelected = watch('mensagem_whatsapp') // adicionar este watch

  const {
    categoriesSistema: { data: categoriesData },
  } = useAgendamentoRetorno()

  const {
    mensagensSistema: { data: messagesData },
  } = useAgendamentoRetorno({
    id_categoria: categorySelected?.value,
  })

  const formattedMessages =
    messagesData?.mensagens_padrao?.map((msg) => ({
      ...msg,
      value: msg.id_mensagem,
      label: msg.conteudo_mensagem,
      preview: msg.link_imagem || msg.conteudo_mensagem, // fallback para o conteúdo se não houver imagem
    })) || []

  return (
    <Flex flexDir="column" gap={2} w="100%" justifyContent="flex-start" alignSelf="flex-start">
      <Select
        name="categoria"
        icon={FiClipboard}
        label={categorySelected ? categorySelected.label : 'Selecione uma categoria'}
        options={categoriesData?.categorias_mensagem?.map((cat) => ({
          value: cat.id_categoria,
          label: cat.descricao_categoria,
        }))}
      />
      {categorySelected && (
        <Select
          name="mensagem_whatsapp"
          icon={FiMessageCircle}
          label={messageSelected ? messageSelected.label : 'Selecione uma mensagem'}
          options={formattedMessages}
          hasToolTip
        />
      )}
    </Flex>
  )
}
